export const SECURITY_URL = 'https://vietmeet.example';
